<script setup>
import '@/assets/fonts.css';
import '@/assets/main.css';

import AppHeader from './components/app/AppHeader.vue';
import AppMain from './components/app/AppMain.vue';
import AppFooter from './components/app/AppFooter.vue';
</script>

<template>
  <AppHeader />
  <AppMain />
  <AppFooter />
</template>
